module.exports = __webpack_public_path__ + "static/media/background1.56d58228.png";